import { DRIVER_URL } from "../utils/UrlsUtils";
import { FArticleSmallInterface } from "../interfaces/FArticleInterface";

export const farticleFormToApi = (
  arRef: string,
  formStateFArticle: any
): any => {
  let icecatId = null;
  if (formStateFArticle.icecatId) {
    icecatId = formStateFArticle.icecatId.toString();
  }
  return {
    arRef: (formStateFArticle.arRef ?? arRef).replaceAll(" ", ""),
    arDesign: formStateFArticle.arDesign.value,
    arPublie: formStateFArticle.arPublie,
    arSommeil: formStateFArticle.arSommeil,
    stockManuel: formStateFArticle.stockManuel,
    fArtstocks: formStateFArticle.fArtstocks,
    arCodebarre: formStateFArticle.arCodebarre.replaceAll(" ", ""),
    constructeurRef: formStateFArticle.constructeurRef.replaceAll(" ", ""),
    arPrixach: formStateFArticle.arPrixach,
    arCoef: formStateFArticle.arCoef,
    arPrixven: formStateFArticle.arPrixven,
    fArtclients: formStateFArticle.fArtclients,
    arPoidsnet: formStateFArticle.arPoidsnet,
    faCodefamille: formStateFArticle.faCodefamille,
    arCodefiscal: formStateFArticle.arCodefiscal,
    fArtfourniss: formStateFArticle.fArtfourniss.map((fArtfourniss: any) => {
      return {
        ...fArtfourniss,
        afReffourniss: fArtfourniss.afReffourniss.replaceAll(" ", ""),
      };
    }),
    arSuivistock: formStateFArticle.arSuivistock,
    fArticleProp: {
      name: formStateFArticle.arDesign.value,
      arCodebarre: formStateFArticle.arCodebarre,
      ensembles: formStateFArticle.ensembles,
      icecatId: icecatId,
      constructeurRef: formStateFArticle.constructeurRef,
      model: formStateFArticle.model ?? null,
      driver: formStateFArticle?.driver?.id
        ? DRIVER_URL + "/" + formStateFArticle.driver.id
        : null,
      images: formStateFArticle.images,
      fArticleSellings: formStateFArticle.fArticleSellings,
      keywords: formStateFArticle.keywords,
      keywordsIcecat: formStateFArticle.keywordsIcecat,
      spotlight: formStateFArticle.spotlight,
      description: formStateFArticle.description,
      categoryFArticleIds: formStateFArticle.categoryFArticleIds,
      fArticleInfos: formStateFArticle.fArticleInfos,
      tags: formStateFArticle.tags,
      hasAcompte: formStateFArticle.hasAcompte,
      percentAcompte: formStateFArticle.percentAcompte,
      percentageOccasion: formStateFArticle.percentageOccasion,
      fArticleFiles: formStateFArticle.fArticleFiles.map(
        (fArticleFile: any) => {
          if (fArticleFile.file) {
            delete fArticleFile.file;
          }
          return { ...fArticleFile };
        }
      ),
      configurationFArticleOptions:
        formStateFArticle.configurationFArticleOptions,
    },
    fArtgloss: formStateFArticle.fArtgloss,
  };
};

export const formatReference = (reference: string): string => {
  return reference
    .toUpperCase()
    .replaceAll(" ", "_")
    .replaceAll(new RegExp("[^a-zA-Z0-9$%+-./_]", "g"), "/")
    .substring(0, 30);
};

export const getPrixDeRevient = (fArticle: FArticleSmallInterface) => {
  let prixDeRevient = null;
  if (fArticle.prixDeRevient && fArticle.prixDeRevient.length > 0) {
    prixDeRevient =
      fArticle.prixDeRevient.reduce((total, p) => {
        return total + Number(p.dlPrixru);
      }, 0) / fArticle.prixDeRevient.length;
  }
  return prixDeRevient;
};
